"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPropertyGroup = void 0;
var OrderPropertyGroup;
(function (OrderPropertyGroup) {
    OrderPropertyGroup[OrderPropertyGroup["DepartureDate"] = 0] = "DepartureDate";
    OrderPropertyGroup[OrderPropertyGroup["DepartureTime"] = 1] = "DepartureTime";
    OrderPropertyGroup[OrderPropertyGroup["PickupAddress"] = 2] = "PickupAddress";
    OrderPropertyGroup[OrderPropertyGroup["PassengersCount"] = 3] = "PassengersCount";
    OrderPropertyGroup[OrderPropertyGroup["Passengers"] = 4] = "Passengers";
})(OrderPropertyGroup || (exports.OrderPropertyGroup = OrderPropertyGroup = {}));
//# sourceMappingURL=OrderPropertyGroup.js.map